/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import LoadingContent from 'components/LoadingContent';
import { checkEnableParseJSON, userpilotDomain } from 'components/helper/helper';
import { normalizeMajorCategoryInterest } from 'constants/majorCategoryLegacy';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { useFormik } from 'formik';
import { USER_ROLE } from 'constants/common';
import AutocompleteInput from 'components/input/AutoCompleteInput';
import collegeServices from 'services/collegeServices';
import authorizationServices from 'services/authorizationServices';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import toast from 'react-hot-toast';
import { Userpilot } from 'userpilot';
import { getAccessToken, getUserId, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';

const SettingsMajor = () => {
  const [loading, setLoading] = React.useState(false);
  const [waiting, setWaiting] = React.useState(false);
  const [majorOptions, setMajorOptions] = React.useState<string[]>([]);
  const information = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const role = information?.user_role ?? '';
  const dispatch = useAppDispatch();
  const history = useHistory();

  const formCreateInfo = useFormik({
    initialValues: {
      email: '',
      first_name: '',
      last_name: '',
      user_role: USER_ROLE.student,
      school_or_organization_work_with: '',
      year_finish_high_school: '',
      password: '',
      password_confirm: '',
      additional_info: {
        where_attend_high_school: '',
        school_system: '',
        high_school_name: '',
        majors_interest_1: '',
        majors_interest_2: '',
        year_plan_college_studies: '',
      },
    },
    onSubmit: async () => {
      const studentId = getUserId();
      try {
        setWaiting(true);
        if (getUserRole() === USER_ROLE.student && studentId) {
          await authorizationServices.updateStudent(studentId, {
            ...formCreateInfo.values,
            additional_info: JSON.stringify(formCreateInfo.values.additional_info),
          });
        }
        Userpilot.identify((studentId ?? 'undefined') + userpilotDomain(role), {
          majors_interest_1:
            formCreateInfo.values.additional_info?.majors_interest_1 ?? 'undefined',
          majors_interest_2:
            formCreateInfo.values.additional_info?.majors_interest_2 ?? 'undefined',
        });

        window.Intercom('update', {
          major_1: formCreateInfo.values.additional_info?.majors_interest_1 ?? '',
          major_2: formCreateInfo.values.additional_info?.majors_interest_2 ?? '',
        });

        toast.success('Save successfully');
      } catch (ex) {
        console.log('Error: ', ex);
      }
      setWaiting(false);
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      const options = await collegeServices.getMajorInterestCategoryOptions('');
      if (cancelled) return;
      setMajorOptions(options);

      const studentId = getUserId();
      const token = getAccessToken();
      if (!token || !studentId) {
        handleLogout();
        return;
      }

      setLoading(true);
      try {
        const res: any = await authorizationServices.getStudent(studentId);
        if (cancelled || !res) return;
        const additionalInfo = checkEnableParseJSON(res.additional_info);
        formCreateInfo.resetForm({
          values: {
            ...res,
            additional_info: {
              ...additionalInfo,
              majors_interest_1: normalizeMajorCategoryInterest(
                additionalInfo?.majors_interest_1,
                options,
              ),
              majors_interest_2: normalizeMajorCategoryInterest(
                additionalInfo?.majors_interest_2,
                options,
              ),
            },
          },
        });
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="tab-wrap-panel">
      <div className="tab-panel">
        <div className="text-left" style={{ paddingBottom: '16px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex align-items-center">
                <div
                  className="text-primary p-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center"
                  style={{ width: '35px', height: '35px', marginRight: '8px' }}
                >
                  <SchoolOutlinedIcon
                    className="text-primray-light"
                    width={'18px'}
                    height={'18px'}
                  />
                </div>
                <div className="text-primary fs-4 fw-bold mx-1">Majors of Interests</div>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            {getUserRole() === USER_ROLE.student && majorOptions?.length ? (
              <div className="row">
                <AutocompleteInput
                  onChange={(val: any) => {
                    formCreateInfo.setFieldValue('additional_info.majors_interest_1', val);
                  }}
                  option={majorOptions}
                  label="Major of interest 1"
                  name="additional_info.majors_interest_1"
                  values={formCreateInfo.values.additional_info?.majors_interest_1}
                  mdCol={'6'}
                />
                <AutocompleteInput
                  onChange={(val: any) => {
                    formCreateInfo.setFieldValue('additional_info.majors_interest_2', val);
                  }}
                  option={majorOptions}
                  label="Major of interest 2"
                  name="additional_info.majors_interest_2"
                  values={formCreateInfo.values.additional_info?.majors_interest_2}
                  mdCol={'6'}
                />
              </div>
            ) : null}

            <div className="row">
              <div className="my-3 d-md-flex justify-content-end" style={{ paddingLeft: 0 }}>
                <Button
                  variant="primary"
                  onClick={() => formCreateInfo.handleSubmit()}
                  className="btn-update"
                >
                  {waiting ? <Spinner size="sm" animation="border" variant="white" /> : 'Update'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsMajor;
